import { API } from "../../apiSlice";

export const loanRepaymentApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    loanRepayment: builder.mutation({
      query: (data) => {
        return {
          url: "users/repay-loan",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useLoanRepaymentMutation } = loanRepaymentApiSlice;
